var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUserProfile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.29688 18.6406L2.29721 15.6403C2.2974 13.9836 3.64049 12.6406 5.29721 12.6406H11.2968M13.7969 15.1406L14.7969 16.1406L18.2969 12.6406M12.2969 5.64062C12.2969 7.29748 10.9537 8.64062 9.29687 8.64062C7.64002 8.64062 6.29687 7.29748 6.29687 5.64062C6.29687 3.98377 7.64002 2.64062 9.29687 2.64062C10.9537 2.64062 12.2969 3.98377 12.2969 5.64062Z",
    stroke: "#5579F0",
    strokeWidth: 1.68587,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserProfile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/UserProfile.b8057dfc.svg";
export { ForwardRef as ReactComponent };